import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const EMPTY_MAP = {};

const useScrollToHash = ({ defaultId, pathMap }) => {
  const location = useLocation();
  const map = pathMap || EMPTY_MAP;

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    const targetId = hash || map[location.pathname] || defaultId;
    if (!targetId) return;
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.pathname, location.hash, defaultId, map]);
};

export default useScrollToHash;
